import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import { getStripeClientSecret } from "components/Cart/utils";
import { PUBLISHABLE_KEY } from "constants/stripe";

const stripePromise = loadStripe(PUBLISHABLE_KEY);

export interface StripeProps {
  clientSecret: string;
}

interface ChildrenProps {
  children: React.ReactNode;
}

interface Props extends StripeProps, ChildrenProps {}

export const StripeElements = ({ clientSecret, children }: Props) => {
  const appearance: { theme: "none" | "stripe" | "night" | "flat" | undefined } = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Elements options={options} stripe={stripePromise} key={clientSecret}>
      {children}
    </Elements>
  );
};

interface ResultProps extends ChildrenProps {
  onLoadingHandler?: (isLoading: boolean) => void;
}

export const StripeElementsForResult = ({ children, onLoadingHandler }: ResultProps) => {
  const [clientSecret, setClientSecret] = useState<string | null>();

  useEffect(() => {
    const secret = getStripeClientSecret();
    setClientSecret(secret);

    if (!secret && onLoadingHandler) {
      onLoadingHandler(false);
    }
  }, [onLoadingHandler]);

  if (!clientSecret) {
    return null;
  }

  return <StripeElements clientSecret={clientSecret}>{children}</StripeElements>;
};
